import { apiSlice, TagType } from "@/features/api/apiSlice.ts"
import { type SuggestedQuestion } from "@/features/assistant/types/assistant.ts"

const SUGGESTED_QUESTIONS_BASE_URL = "suggested-questions/"

export const suggestedQuestionsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSuggestedQuestions: builder.query<SuggestedQuestion[], void>({
      query: () => SUGGESTED_QUESTIONS_BASE_URL,
      providesTags: [{ type: TagType.SuggestedQuestions, id: "LIST" }],
    }),
  }),
})

export const { useGetSuggestedQuestionsQuery } = suggestedQuestionsApi
